import { LayoutAnimation } from 'react-native';

export const animateNext = (callback?: CallableFunction) => {
  LayoutAnimation.configureNext({
    duration: 150,
    create: {
      type: LayoutAnimation.Types.easeInEaseOut,
      property: LayoutAnimation.Properties.opacity,
    },
    update: {
      type: LayoutAnimation.Types.easeInEaseOut,
    },
  });
  if (callback) {
    callback();
  }
};
